import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      setBusiness(res.data.business || null);
    } catch {
      setUser(null);
      setBusiness(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Session lives in an httpOnly cookie set by the server; the token argument is ignored.
  const login = (_token, userData) => {
    setUser(userData);
    refresh();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* local sign-out continues */ }
    setUser(null);
    setBusiness(null);
  };

  return (
    <AuthContext.Provider value={{ user, business, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}
